import React, {useEffect, useState} from "react";
import {Form, Input, Modal, Select} from "antd";
import {FormModalProps} from "../../../../utils/useFormModal";
import * as api from "../../../../apis/platforms/admin/expressFreight"
import DictSelect from "../../../../components/DictSelect";
import {useRequest} from "ahooks";
import {addWeightItem} from "../../../../apis/platforms/admin/expressFreight";

export default function AddModal(props: FormModalProps) {

    const {form, ...otherProps} = props
    const [expressList, setExpressList] = useState<Array<any>>([])

    useEffect(() => {
        getExpressList()
    }, [])

    const {run: getExpressList} = useRequest(api.getExpressList, {
        manual: true,
        onSuccess: (res) => {
            setExpressList(res.data.data.map((item: any) => {
                return {
                    label: item.name,
                    value: item.id
                }
            }))
        }
    })

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'expressId'} label={'快递公司'} rules={[{required: true}]}>
                    <Select options={expressList}/>
                </Form.Item>
                <Form.Item name={'rule'} label={'计费规则'} rules={[{required: true}]}>
                    <DictSelect dict={'BillingRule'} appendNull={false}/>
                </Form.Item>
                <Form.Item dependencies={['rule']} noStyle>
                    {({getFieldValue}) => {
                        const rule = getFieldValue('rule')
                        return rule ? (
                            <Form.Item label={'规则描述'}>
                                <span
                                    style={{color: "red"}}>{rule === 'weight' ? '首重价格+续重单价*Roundup{(订单重量-首重)/续重}' : '单箱价格*Roundup(商品数量/箱的基数)'}
                                </span>
                            </Form.Item>
                        ) : null
                    }}
                </Form.Item>
            </Form>
        </Modal>
    )
}